module.exports = __webpack_public_path__ + "media/home.8acd54e5.mp4";